module.exports = __webpack_public_path__ + "static/media/wrong-ipv-three.5e611721.svg";